import $ from 'jquery'
import DropdownDialog from '../controls/DropdownDialog'
import {escapeHtmlSymbols, isNotEmpty} from '../atUtils'
import SpinnerController from '../SpinnerController'
import Spinner from "./../spin.min"
import {ReportConfigConstants} from 'constants'
import messageResource from '../messageResource'
import json2csv from '../json2csv/json2csv'
import {downloadPDF} from '../pdf/utils'

export default function ReportMediator ()
{
    this.constructor = ReportMediator;
}

ReportMediator.prototype.init = function ( config )
{
    var self = this;
    this.editConfigurationButton = $( config.editConfigurationButton );
    this.exportToCsvButton = $( ".exportToCSV" );
    this.panelEl = $( config.panelId );

    this.reportPlaceholder = $("#reportPlaceholder");
    this.reportOverlay = $("#reportOverlay");

    this.generateReportUrl = config.generateReportUrl;
    this.generateCSVUrl = config.generateCSVUrl;
    this.reportParameters = config.reportParameters;
    this.reportConfigId = config.reportConfigId;
    this.reportConfigName = config.reportConfigName;

    this.dataWasChanged = false;

    ATReportsStore.setReportAuthorizationInfo(config.reportAuthorizationInfo)
    ATReportsStore.setManageableUserIds(config.manageableUserIds)
    ATReportsStore.setProjectsWithMaIds(config.projectsWithMaIds)

    this.initReportParameters = $.extend({}, this.reportParameters);
    this.historyController = new HistoryController().init( {
                                                               onPopstate: function (e) {
                                                                   // NOTE: chrome! strange behaviour 
                                                                   // (it adds # (anchor) to url after confirmation closed so onPopstate event is triggered ).
                                                                   if ( e.state != null ) 
                                                                       self.generateReportFromHistory(); 
                                                               },
                                                               initState: this._makeHistoryState()
                                                           });
    this.updateParametersFromHistory()

    //NOTE: ugly hack. this.reportParameters might be changed somewhere before but all selectors are initialized from config.
    //NOTE: this.reportParameters can be modified by method updateParametersFromHistory, this need to keep not saved parameters between reloads
    //NOTE: for example see https://jira.actimind.com/browse/AT-3523
    $.extend(config.reportParameters, this.reportParameters)
    
    this.editConfigController = this.initEditConfigController( config );
    this.initEditConfigButtons();

    this.saveConfigControl = new SaveConfigurationControl().init({
                                                                    reportName: config.reportConfigName,
                                                                    reportType: this.getReportType(),
                                                                    hasChanges: this.dataWasChanged
                                                                 },
                                                                 SaveConfigurationControl.REPORT_TYPE,
                                                                 function(reportName){
                                                                     self.saveReportManager.saveReport(
                                                                             {
                                                                                  reportName: reportName,
                                                                                  reportType: self.getReportType(),
                                                                                  reportParameters: self.reportParameters
                                                                             }
                                                                     )
                                                                 },
                                                                 function(reportName){
                                                                     self.saveReportManager.updateReport(
                                                                             {
                                                                                  reportId: self.reportConfigId,
                                                                                  reportName: reportName,
                                                                                  reportType: self.getReportType(),
                                                                                  reportParameters: self.reportParameters
                                                                             }
                                                                     )
                                                                 },
                                                                 function() {
                                                                    return self._resetReport();
                                                                 }
    );
    this.saveReportManager = this.getConstructorSaveManager().init(
            this.saveConfigControl,
            function( reportId, newConfigName )
            {
                self.commonSuccessSaveHandler( reportId, newConfigName )
            },
            self._noRightsHandler
    );

    this.editConfPanelwrapperClassName = "editReportConfigurationWrapper ";
    var wrapperClass = this.editConfPanelwrapperClassName + (config.additionalPanelClass ? " "+ config.additionalPanelClass : "");

    this.panel = new DropdownDialog( {
                                         wrapperClass: wrapperClass,
                                         dialogDiv: this.panelEl,
                                         hideButtons: true,
                                         hideOnResize: true,
                                         showEmptyTitleBar: false,
                                         outsideClickCallback: function () {self.editConfigCanceled();},
                                         hideOnResizeCallback: function () {self.editConfigCanceled();},
                                         onClose: function ( event )
                                         {
                                             if ( event.keyCode === $.ui.keyCode.ESCAPE )
                                                self.editConfigCanceled();
                                             
                                             self.editConfigurationButton.removeClass("active");
                                         }
                                     } );

    this.editConfigurationButton.click( function (el)
                                   {
                                       self.editConfigurationButton.addClass("active");

                                       if ($(el.target).parents(".reportPageHeader" ).length)
                                           self.panel.showAt( this, {
                                               offset: "0 10px",
                                               my: "left top",
                                               at: "left bottom",
                                               collision: "none"
                                           } );
                                       else
                                           self.panel.showAt( this, {
                                               offset: "0 -10px",
                                               my: "left bottom",
                                               at: "left top",
                                               collision: "none flip"
                                           } );

                                       var panelTop = $(self.panelEl).offset().top;
                                       var panelWrapper = $("." + self.editConfPanelwrapperClassName);
                                       if (panelTop < $(el.target).offset().top) {
                                           panelWrapper.addClass("toTop");
                                           panelWrapper.removeClass("toBottom");
                                       }
                                       else {
                                           panelWrapper.addClass("toBottom");
                                           panelWrapper.removeClass("toTop");
                                       }
                                   } );

    this.exportToCsvButton.click( function() {
        self.exportToCSV();
    });

    this.dateRangeSelector = this.createDateRangeSelector(this.reportParameters);
    this.setConfigDateRangeSelection(this.getDateRangeParameter());

    if ( this.dateRangeSelector ) {
        this.dateRangeSelector.setOnChangeCallback( function() {self.onDateRangeChanged()} );
    }

    this.printReportNamePlh = $(".reportPageHeader .printHeader .printableReportName");
    this.printReportNamePlh.text( this.reportConfigName && isNotEmpty(this.reportConfigName) ? this.reportConfigName : config.reportTitle );


    this.printableHeadersBuilder = this.initPrintableHeadersBuilder( config );
    this._createPrintableHeaders();

    return this;
};

ReportMediator.prototype.getConstructorSaveManager = function(){
    return new SaveReportManager();
};

ReportMediator.prototype.changeParametersCallback = function () {
    if( this.editConfigController && !this.editConfigController.validate() )
        this.editConfigController.updateUI(true);
};

ReportMediator.prototype.getReportType = function()
{
    // abstract
};

ReportMediator.prototype.initEditConfigController = function( config )
{
    //abstract
};

ReportMediator.prototype.hasErrors = function()
{
    return (!!this.dateRangeSelector && this.dateRangeSelector.hasErrors()) || this.editConfigController.hasErrors();
};

ReportMediator.prototype.setConfigDateRangeSelection = function( selection ) {
    this.reportParameters.dateRangeSelection = selection;
};

ReportMediator.prototype.onDateRangeChanged = function() {
    this.setConfigDateRangeSelection(this.getDateRangeParameter());
    
    if ( this.hasErrors() )
        return;

    this.dateRangeSelector.setInitStateFromCurrent();
    this.registerChanges();
    this._updatePrintableDateRangeHeader();
    this.generateReport(false); // do not verify if date range really changed
};

ReportMediator.prototype.registerChanges = function(){
    this.dataWasChanged = true;
    this.saveConfigControl.registerConfigChanged();
};


ReportMediator.prototype.editConfigApplied = function( extendedCheck )
{
    if ( !this.editConfigController.validate() ) {
        this.editConfigController.updateUI(true);
        return;
    }

    if( extendedCheck && !extendedCheck() )
        return;

    var newState = this.editConfigController.getConfig();
    $.extend(this.reportParameters, newState);
    this.panel.hide();
    this._createPrintableHeaders();
   
    if ( this.hasErrors() )
        return;
    this.registerChanges();

    this.editConfigController.setSelectorsInitStateFromCurrent();
    this.generateReport(false);
};

ReportMediator.prototype._makeHistoryState = function () {
    return {
        reportParameters: this.reportParameters,
        dataWasChanged: this.dataWasChanged
    };
};

ReportMediator.prototype._saveConfigToHistory = function () {
    this.historyController.saveState(this._makeHistoryState());
};

ReportMediator.prototype.editConfigCanceled = function()
{
    this.editConfigController.resetConfig();
    // validate on close not when popup is opened to prevent error on first opening
    this.editConfigController.validate();
    this.editConfigController.updateUI();
    this.panel.hide();
};

ReportMediator.prototype.initEditConfigButtons = function()
{
    var self = this;
    this.editConfigController.setConfigButtonHandlers({
                                                          onApply: function () {self.editConfigApplied();},
                                                          onCancel: function () {self.editConfigCanceled();}
                                                      });
};

ReportMediator.prototype._resetReport = function(){
    if(this.dataWasChanged)
    {
        this._updateReportParameters( this.initReportParameters );
        this.dataWasChanged = false;
        this.generateReport(false);
    }
   
    return true;
};

ReportMediator.prototype._updateReportParameters = function( reportParameters )
{
    this.reportParameters = $.extend({}, reportParameters);
    this._updateReportControls();
};

ReportMediator.prototype.makeServiceParams = function (reportParams) {
    var serviceParams = _.clone(reportParams);
    serviceParams.dateRangeSelection = {
        qualifier: reportParams.dateRangeSelection.qualifier,
        fromDate: reportParams.dateRangeSelection.fromDate.toJSON(),
        toDate: reportParams.dateRangeSelection.toDate.toJSON()
    };

    return serviceParams;
};

ReportMediator.prototype.getDateRangeParameter = function()
{
    return this.dateRangeSelector.getSelectedRange();
};

ReportMediator.prototype.setDateRangeParameter = function(reportParameters)
{
    this.dateRangeSelector.setSelectedRange(reportParameters.dateRangeSelection);
};

ReportMediator.prototype._createPrintableDateRangeHeader = function ()
{
    return this.printableHeadersBuilder.addDateRangeHeaderStringParsed( this.reportParameters.dateRangeSelection );
};

ReportMediator.prototype.createDateRangeSelector = function( reportParameters ) {
    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems(reportParameters.dateRangeSelection.qualifier),
        dateRangeParsed: true
    };

    return new DateRangeSelectorController().init(dateRangeSelectorConfig);
};

ReportMediator.prototype._updateReportControls = function()
{
    this.setDateRangeParameter(this.reportParameters);
    this.editConfigController.setSelectorsFromReportParameters(this.reportParameters);
    this.editConfigController.resetConfig();
    this._updatePrintableDateRangeHeader();
};

ReportMediator.prototype.exportToCSV = function ()
{
    var form = $( "#reportExportToCSVForm" );
    form.attr( "action", this.generateCSVUrl );
    form.find( "input[name=configId]" ).val( this.reportConfigId );
    form.find( "input[name=reportParameters]" ).val( JSON.stringify( this.reportParameters ) );
    form.submit();
};


ReportMediator.prototype.addReportOverlay = function(){
    if(!this.spinnerOverlay){
        this.spinnerOverlay = new SpinnerController(true);
        this.spinnerOverlay.setSpinner(this.createSpinnerForOverLay());
    }
    var spinnerId = "spinnerReportOverlay";
    this.spinnerOverlay.spin(spinnerId);
    this.reportOverlay.show();

    var self = this;
    var element = this.reportPlaceholder.find("#report-table");
    if (element.length == 0)
        element = this.reportPlaceholder;

    this.offsetSpinnerAndOverlayInCenterElement( spinnerId, element );
    var scrollHandler = function () { self.offsetSpinnerAndOverlayInCenterElement( spinnerId, element ) };
    var resizeHandler = function () { self.offsetSpinnerAndOverlayInCenterElement( spinnerId,element ) };
    $( window ).scroll(scrollHandler);
    $( window ).resize(resizeHandler);
    this.unbindWindowHandlers = function () {
        $( window ).off("scroll", scrollHandler);
        $( window ).off("resize", resizeHandler);
    }
};

ReportMediator.prototype.createSpinnerForOverLay = function(){
    return new Spinner( {
                            lines: 11, // The number of lines to draw
                            length: 6, // The length of each line
                            width: 2, // The line thickness
                            radius: 4, // The radius of the inner circle
                            corners: 1, // Corner roundness (0..1)
                            rotate: 0, // The rotation offset
                            direction: 1, // 1: clockwise, -1: counterclockwise
                            color: '#233446', // #rgb or #rrggbb
                            speed: 1, // Rounds per second
                            trail: 60, // Afterglow percentage
                            shadow: false, // Whether to render a shadow
                            hwaccel: false, // Whether to use hardware acceleration
                            className: 'spinner', // The CSS class to assign to the spinner
                            zIndex: 1001, // The z-index (defaults to 2000000000)
                            top: 'auto', // Top position relative to parent in px
                            left: 'auto' // Left position relative to parent in px
                        } );
};

ReportMediator.prototype.offsetSpinnerAndOverlayInCenterElement = function ( spinnerId, element )
{
    var windowTop = $( window ).scrollTop();
    var windowBottom = $( window ).scrollTop() + $( window ).height();
    var tableTop =  element.offset().top;
    var tableBottom =  element.offset().top +  element.height();

    var windowLeft = $( window ).scrollLeft();
    var windowRight = $( window ).scrollLeft() + $( window ).width();
    var tableLeft =  element.offset().left;
    var tableRight =  element.offset().left + element.width();
    var top = Math.max( windowTop, tableTop );
    var bottom = Math.min( windowBottom, tableBottom );
    var left = Math.max( windowLeft, tableLeft );
    var right = Math.min( windowRight, tableRight );
    top += (bottom-top)/2;
    left +=(right - left) / 2;

    this.reportOverlay.width( Math.ceil( element.width() ) + 2 ); // +2, because table with report has borders
    this.reportOverlay.height(  Math.ceil( element.height() ) + 1 );
    this.reportOverlay.offset( element.position());
    $( "#" + spinnerId ).offset( {top: top, left: left});
};

ReportMediator.prototype.hideOverlay = function(){
    if(this.spinnerOverlay)
        this.spinnerOverlay.stop();
    this.reportPlaceholder.removeClass("empty");
    this.reportOverlay.hide();
    this.unbindWindowHandlers();
};

ReportMediator.prototype.updateParametersFromHistory = function () {
    var state = this.historyController.getState();

    if ( state && state.reportParameters ) {
        this.reportParameters = state.reportParameters;
        this.dataWasChanged = state.dataWasChanged;

        return true;
    }

    return false;
};

ReportMediator.prototype.generateReportFromHistory = function () {
    if ( this.updateParametersFromHistory() ) {
        if ( !this.dataWasChanged ) {
            this.dataWasChanged = true;
            this.historyController.updateState(this._makeHistoryState());
        }
        this.registerChanges();
    }
    
    this._updateReportControls();
    this.generateReport(true);
};

ReportMediator.prototype.generateReport = function ( ignoreHistory )
{
    this.baseGenerateReport(ignoreHistory);
};

ReportMediator.prototype.baseGenerateReport = function ( ignoreHistory, additionalSuccessHandler )
{
    if ( !ignoreHistory )
        this._saveConfigToHistory();
    
    var self = this;
    var customErrorHandler = function( errorCode, errorMessage )
    {
        if (errorCode === ReportConfigConstants.LEAVES_REPORT_ALL_SELECTED_LEAVES_DELETED)
        {
            self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.no_selected_leave_types"));
            return true;
        }
        if (errorCode === ReportConfigConstants.NO_RIGHTS_FOR_MANAGING_PTO_AND_SICK)
        {
            if ( EnabledFeatures.PTO && EnabledFeatures.SDB )
            {
                self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.no_rights_manage_pto_and_sick"));
            }
            else if ( EnabledFeatures.PTO )
            {
                self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.no_rights_manage_pto"));
            }
            else if ( EnabledFeatures.SDB )
            {
                self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.no_rights_manage_sick"));
            }
            return true;
        }
        if (errorCode === ReportConfigConstants.ALL_SELECTED_FOR_REPORT_USERS_WERE_DELETED)
        {
            self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.no_selected_users"));
            return true;
        }
        if (errorCode === ReportConfigConstants.OVERTIME_FOR_ALL_SELECTED_USERS_WAS_DISABLED)
        {
            self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.no_selected_overtime_users"));
            return true;
        }
        if (errorCode === ReportConfigConstants.ALL_SELECTED_FOR_REPORT_PROJECTS_ARE_UNAVAILABLE_OR_DELETED)
        {
            self.showReportLoadingError(messageResource.getEscapedMessage("report.js.report_loading_error.no_selected_projects"));
            return true;
        }
        if (errorCode === ReportConfigConstants.NO_BILLABLE_TASKS)
        {
            self.showReportLoadingError(messageResource.getEscapedMessage("report.js.report_loading_error.no_billable_tasks"));
            return true;
        }
        if (errorCode === AJAX_USER_ACTION_ERROR_CODES.NO_RIGHTS)
        {
            alert( JQUERY_RPC_ERROR_MESSAGES.NO_RIGHTS );
            document.location.href = ReportConfigConstants.REPORTS_DASHBOARD_URL;
            return true;
        }
        if (errorCode == AJAX_USER_ACTION_ERROR_CODES.ERROR_STATE || errorCode == AJAX_USER_ACTION_ERROR_CODES.UNEXPECTED_ERROR)
        {
            self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.unexpected_error", [PRODUCT_NAME]));
            if( errorMessage )
                console.log( errorMessage );
            return true;
        }
        return false;
    };

    var unknownErrorHandler = function( jqXHR )
    {
        if( jqXHR.status >= 100 && jqXHR.status < 1000 )
            self.showReportLoadingError( JQUERY_RPC_ERROR_MESSAGES.HTTP_ERROR + " " + jqXHR.status + " " + jqXHR.statusText );
        else
            self.showReportLoadingError( messageResource.getMessage("report.js.report_loading_error.network_error", [PRODUCT_NAME]) );
    };

    var errorHandler = function( jqXHR, textStatus )
    {
        self.hideOverlay();
        switch ( textStatus )
        {
            case 'abort':
                break;  // the request was aborted by the calling code; do nothing

            case 'timeout':
                self.showReportLoadingError( messageResource.getMessage("report.js.report_loading_error.timeout", [PRODUCT_NAME]) );
                break;

            case 'error':
                handleAjaxUserActionError( jqXHR.status, jqXHR.responseText, customErrorHandler, unknownErrorHandler );
                break;

            default:
                self.showReportLoadingError( messageResource.getMessage("report.js.report_loading_error.unexpected_error", [PRODUCT_NAME]) );
        }
    };

    var successHandler = function( data )
    {
        if (!self.validateGeneratedReport(data))
            return;

        self.renderGeneratedReport(data);

        self.hideOverlay();

        if (additionalSuccessHandler)
            additionalSuccessHandler();
    };

    if (this.generateReportRequest)
        this.generateReportRequest.abort();

    this.addReportOverlay();
    this.generateReportRequest = this.requestGenerateReport(successHandler, errorHandler)
};

ReportMediator.prototype.requestGenerateReport = function(successHandler, errorHandler)
{
    return $.ajax({
                      url: this.generateReportUrl,
                      type: 'POST',
                      data: {configId: this.reportConfigId, configName: this.saveConfigControl.getReportConfigName(), reportParameters: JSON.stringify(this.reportParameters)},
                      success: successHandler,
                      error: errorHandler,
                      timeout: 120000
                  });
};

ReportMediator.prototype.validateGeneratedReport = function(data)
{
    if (!data || data.length == 0)
    {
        this.hideOverlay();
        this.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.html_report_to_big"));
        return false;
    }

    return true;
};

ReportMediator.prototype.renderGeneratedReport = function(data)
{
    this.reportPlaceholder.empty();
    this.reportPlaceholder.append(data);
};

ReportMediator.prototype.showReportLoadingError = function( errorMessage )
{
    this.reportPlaceholder.html('<div class="reportLoadingError">' + errorMessage + '</div>');
    this.onReportLoadingError();
};

ReportMediator.prototype.onReportLoadingError = function() {
    // abstract
};

ReportMediator.prototype.commonSuccessSaveHandler = function ( reportId, newConfigName ) {
    if( reportId )
        this.reportConfigId = reportId;
    $.extend(this.initReportParameters, this.reportParameters);

    this.dataWasChanged = false;

    if( this.historyController.isSupported() )
        this.historyController.setUrlParam(this._makeHistoryState(), "?configId=" + this.reportConfigId);
    else
        window.location.href = window.location.pathname + "?configId=" + this.reportConfigId;

    this.printReportNamePlh.text( newConfigName );
};

ReportMediator.prototype._noRightsHandler = function ( errorThrown ) {
    if( errorThrown.exception && errorThrown.exception.indexOf( 'com.actimind.actitime.services.NoRightsForRemoteCallException' ) != -1 )
    {
        alert( JQUERY_RPC_ERROR_MESSAGES.NO_RIGHTS );
        document.location.href = ReportConfigConstants.REPORTS_DASHBOARD_URL;
        return true;
    }
    
    return false;
};

ReportMediator.prototype._createPrintableHeaders = function ()
{
    var headersArray = [];
    this._clearPrintableHeadersFromPage();
    this._populateHeadersArray( headersArray );
    this._addPrintableHeadersToTable( headersArray );
};

ReportMediator.prototype._clearPrintableHeadersFromPage = function ()
{
    $( '#printableDateRangeHeader' ).empty();
    $( '#printableHeadersContainer' ).empty();
};

ReportMediator.prototype._addPrintableHeadersToTable = function ( headersArray )
{
    this._updatePrintableDateRangeHeader();

    var container = $( '#printableHeadersContainer' );
    var table = $( '<table cellspacing="0" cellpadding="2" id="printableHeadersTable">' );

    for( var i = 0; i < headersArray.length; i++ )
    {
        table.append( this._createPrintableHeaderRow( headersArray[i] ) );
    }
    container.append( table );
};

ReportMediator.prototype._updatePrintableDateRangeHeader = function (  )
{
    $( '#printableDateRangeHeader' ).html( this._createPrintableDateRangeHeader() );
};

ReportMediator.prototype._createPrintableHeaderRow = function ( header )
{
    return [
        '<tr class="reportParamRow">',
            '<td class="text printableHeaderLabelTD">',
                '<nobr>',
                    '<span class="formblocktitle">', header.label, '</span>',
                '</nobr>',
            '</td>',
            '<td class="text printableHeaderValueTD">', header.value, '</td>',
        '</tr>'
    ].join( '' );
};

ReportMediator.prototype.initPrintableHeadersBuilder = function ( config )
{
    //abstract
};

ReportMediator.prototype._populateHeadersArray = function ( headersArray )
{
    //abstract
};

ReportMediator.prototype.getEventName = function(event)
{
    // abstract
};

ReportMediator.prototype.initPDFEvents = function()
{
    var self = this;
    $(document).on(this.getEventName("showPDFPreview"), function()
    {
        self.pdfPreviewLightbox.show();
    });
    $(document).on(this.getEventName("pdfPreview.lightbox.hide"), function()
    {
        //do nothing
    });
    $(document).on(this.getEventName("pdfPreview.printParametersForSaveChange"), function(event, printParametersForSave)
    {
        self.store.setPrintParametersForSave(printParametersForSave);
    });
    $(document).on(this.getEventName("pdfPreview.printParametersForGenerateChange"), function(event, printParametersForGenerate)
    {
        self.store.setPrintParametersForGenerate(printParametersForGenerate);
        self.cancelAllPDFExportingProcesses();
        self.generatePDF();
    });
    $(document).on(this.getEventName("downloadPDF"), function()
    {
        downloadPDF(self.store.getGeneratedPDF(), self.store.getPDFFileName());
    });
};

ReportMediator.prototype.initCSVEvents = function()
{
    var self = this;
    $(document).on(this.getEventName("createCSV"), function()
    {
        self.generateCSV();
    });
};


// WEBPACK FOOTER //
// ./web/js/reports/ReportMediator.js